module.exports = __webpack_public_path__ + "static/baby2-805606f9e4700893469bbd3ed326fe7a.jpg";